module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-500-[84]327.80955de.woff2";